import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta11Model } from './model-consultaSeguimentoPergunta11'
import {
  hasPergunta11ExemplosFalhouAnySim,
  hasPergunta11ExemplosPassouAnySim,
  isPergunta11ExemplosAllFilled,
  isPergunta11ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta11'

export const PERGUNTA_11_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta11Model> = {
  PERGUNTA_11_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_11_EXEMPLOS',
      },
    ],
  },
  PERGUNTA_11_EXEMPLOS: {
    scrollConditions: [
      {
        if: (value) => isPergunta11ExemplosAllNao(value),
        scrollTo: 'BOTTOM',
      },
      {
        if: (value) =>
          isPergunta11ExemplosAllFilled(value) &&
          hasPergunta11ExemplosPassouAnySim(value) &&
          !hasPergunta11ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta11ExemplosAllFilled(value) &&
          !hasPergunta11ExemplosPassouAnySim(value) &&
          hasPergunta11ExemplosFalhouAnySim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) =>
          isPergunta11ExemplosAllFilled(value) &&
          hasPergunta11ExemplosPassouAnySim(value) &&
          hasPergunta11ExemplosFalhouAnySim(value),
        scrollTo: 'PERGUNTA_11_FREQUENCIA',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_11_HEADER',
  },
  PERGUNTA_11_FREQUENCIA: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_11_EXEMPLOS',
  },
}
